module.exports = __webpack_public_path__ + "img/slide-13.3753263a.jpg";